// ** The datalayer will get dirty values if same parameters are used to assign different values on each event. E.g. play_start event values will look fine on
// ** player start, but then progress_25% occurs the play_start will have lost it initial values and have received random values instead.
// ** This way we keep dedicated parameters for each value for each event. //Sehpast

export class Ga4Data {

   ga4DataEventPlay = { 
        video_provider: 'JW Player',
        video_title: '',
        video_url: '',
        video_current_time: 0,
        video_percent: 0,
        video_duration: 0,
        visible: 1,
    };

    ga4DataEventProgress25 = { 
        video_provider: 'JW Player',
        video_title: '',
        video_url: '',
        video_current_time: 0,
        video_percent: 25,
        video_duration: 0,
        visible: 1,
    };

    ga4DataEventProgress50 = { 
        video_provider: 'JW Player',
        video_title: '',
        video_url: '',
        video_current_time: 0,
        video_percent: 50,
        video_duration: 0,
        visible: 1,
    };

    ga4DataEventProgress75 = { 
        video_provider: 'JW Player',
        video_title: '',
        video_url: '',
        video_current_time: 0,
        video_percent: 75,
        video_duration: 0,
        visible: 1,
    };

    ga4DataEventComplete = { 
        video_provider: 'JW Player',
        video_title: '',
        video_url: '',
        video_current_time: 0,
        video_percent: 100,
        video_duration: 0,
        visible: 1,
    };

}